const styles = {
  containerStyle: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    position: 'relative',
    paddingTop: '20px',
    marginTop: '-20px',
  },

  // actions
  actionsContainer: {
    position: 'absolute',
    top: -14,
    left: '50%',
    transform: 'translateX(-30%)',
    display: 'flex',
    gap: '5px',
    zIndex: 20,
  },
  actionIcon: {
    padding: '16px',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',

    '&:hover': {
      background: 'rgba(60, 60, 70, 0.08)',
      boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
    },
  },

  // node
  baseStyles: {
    width: '80px',
    height: '80px',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
    borderRadius: '8px',
    position: 'relative' as const,
  },
  handle: {
    background: '#6F7287',
    width: '8px',
    height: '8px',
    border: 'none',
    zIndex: 1,
  },
  nodeLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#101828',
    marginTop: '8px',
    textAlign: 'center',
  },

  // bottom
  documentsConteiner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '4px',
    backgroundColor: '#FFFFFF',
    borderRadius: '4px',
    padding: '4px 8px',
    border: '1px solid #E5E7EB',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
  },
  documentIcon: {
    width: '16px',
    height: '16px',
    marginRight: '4px',
  },
  documentLabel: {
  }
}

export default styles;
